import Component from './TreeBranchIcon.component';

export default Component;
